<template>
  <div class="esp_page_card" :style="{ height: pageHeight }">
    <!-- 标题 -->
    <div class="esp_card_title">
      <div style="display: flex;align-items: center;">
        <div class="esp-card-name">
          <slot name="left">{{ title }}</slot>
        </div>
        <div>
          <slot name="btn">
          </slot>
        </div>
      </div>
      <div class="esp_card_title_btn">
        <slot name="right">
          <div style="height: 30px"></div>
        </slot>
      </div>
    </div>
    <!-- 内容 -->
    <div class="esp_card_content" :style="{height: contentHeight,paddingLeft:paddingLeft,paddingRight:paddingRight}">
      <el-scrollbar v-if="useScrollbar" style="padding-bottom: 17px; overflow-x: hidden;height: 100%;">
        <div style="padding: 0px 0px 8px 0px;">
          <slot></slot>
        </div>
      </el-scrollbar>
      <slot v-else></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "EspPageCard",
  data() {
    return {
      content_height: "auto"
    }
  },
  props: {
    title: {
      type: String,
      default: "-"
    },
    height: {
      type: String,
      default: "auto"
    },
    paddingLeft: {
      type: String,
      default: "10px"
    },
    paddingRight: {
      type: String,
      default: "10px"
    },
    useScrollbar: {         // 是否使用滚动条
      type: Boolean,
      default: true
    }
  },
  methods: {},
  created: function () {

  },
  computed: {
    pageHeight: function () {
      if (this.height != "auto") {
        return "calc(" + this.height + ")";
      } else {
        return "auto"
      }
    },
    contentHeight: function () {
      if (this.height != "auto") {
        return "calc(100% - 50px)";
      } else {
        return "auto"
      }
    },
  },
}
</script>


<style scoped>
.esp_page_card {
  background: white;
}

.esp_page_card .esp_card_title {
  /*border-bottom: 0.2px solid #eaeaea;*/
  font-family: Helvetica Neue, Tahoma, PingFang SC, Hiragino Sans GB, Microsoft YaHei, STHeitiSC, sans-serif;
  font-size: 14px;
  font-weight: 600;
  padding: 10px 10px 5px 10px;
  display: flex;
  justify-content: space-between;
}

.esp_page_card .esp_card_title_btn {
  float: right;
  font-weight: bold;
  display: flex;
  align-items: center;
}

.esp_page_card .esp_card_content {
  /*padding: 0px 0px 0px 10px;*/
  padding-right: 10px;
}

.esp_page_card .esp_scrolbar_height {
  height: 100%;
}

.esp_page_card .esp_card_title:after {
  /*content: "";*/
  /*display: block;*/
  /*clear: both;*/
}

.esp-card-name {
  border-left: 4px solid #27B671;
  padding-left: 8px;
  color: #27B671;
  height: 14px;
  line-height: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/EspPageCard.vue